import React, { lazy, Suspense, useRef, useState } from 'react';
import { Redirect, Route, Switch, useParams } from 'react-router';
import parse from 'html-react-parser';

function Help() {
  const code =
    '<iframe style="border:none;"width="100%" height="100%" src="https://secure.webbookingpro.com/index.php?admin=mod_invoices"></iframe>';
  return parse(code);
}

export default Help;
